import styled from "styled-components";

export const StyledModal = styled.div`
  @media (min-width: 800px) {
    .Polaris-LegacyStack {
      flex-wrap: nowrap;
    }
  }
`;

export const FieldSetQty = styled.div`
  float: right;
  .Polaris-TextField__Input {
    max-width: 70px;
    display: inline-block;
  }
`;
